import { CustomTable, InputDate } from "medere-ui-framework"
import { useId, useRef, useState, BaseSyntheticEvent } from "react"
import { Column } from "primereact/column"
import { Button } from "primereact/button"
import { getVATPurchases, exportVATPurchases, downloadFile, getAliquotTotalizers } from "../servicesHooks/Accounting/useAccountingService"

function VATPurchasesView() {
    const today = new Date()
    const tableRef = useRef(null)
    const [fromDate, setFromDate] = useState<Date>(generateFromDate())
    const [toDate, setToDate] = useState<Date>(generateToDate())

    function handleGeneratePDF() {
        if (fromDate && toDate)
            exportVATPurchases(fromDate, toDate)
            .then((res) => {
                downloadFile(res, "vat_purchases_report.pdf")
            }).catch((err)=>{
                console.error("error: ", err)
            })
        else
            console.log("fromDate o toDate undefined")
    }

    function generateFromDate() {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 1);

        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = 1;

        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;

        const formattedDate = `${year}-${formattedMonth}-${formattedDay}T03:00:00.000Z`;

        return new Date(formattedDate);
    }

    function generateToDate() {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate());
      
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = currentDate.getDate();
      
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;
      
        const formattedDate = `${year}-${formattedMonth}-${formattedDay}T03:00:00.000Z`;
      
        return new Date(formattedDate);
    }

    return (
        <div className="p-4 flex flex-column viewContainer">
            <h2 className="text-2xl">Libro IVA Compras</h2>
            
            <div className='flex align-items-end justify-content-between gap-3'>
                <div className="flex flex-row gap-3 w-1/2">
                    <InputDate value={fromDate} label='Desde' onChange={(e: BaseSyntheticEvent) => {
                        setFromDate(e.target.value)
                    }}
                        className='w-1/2'
                        maxDate={today}
                    />

                    <InputDate value={toDate} label='Hasta' onChange={(e: BaseSyntheticEvent) => {
                        setToDate(e.target.value)
                    }}
                        className='w-1/2'
                        maxDate={today}
                    />
                </div>

                <div className="flex flex-end">
                    <Button
                        className="buttonMain"
                        icon='pi pi-file'
                        onClick={() => handleGeneratePDF()}
                    />     
                </div>
            </div>

            <CustomTable
                idTable={useId()}
                ref={tableRef}
                showGridlines
                hideFiltersButton
                getItems={getVATPurchases}
                params={{ 
                    fromDate: fromDate,
                    toDate: toDate
                }}
                className='crudTable'
            >
                <Column field="formdate" header="Fecha" className="columnGen column100px" body={(record) => {
                        const formattedDate = new Date(record.formdate).toLocaleDateString('es-ES');
                        return <span style={{ paddingTop: '2px', paddingBottom: '3px', paddingLeft: record.billingdocument === 'TOTALES'?'50%':'', paddingRight: record.billingdocument === 'TOTALES'?'50%':'', background: record.billingdocument === 'TOTALES'? '#FAFFB2' : 'inherit' }}>{record.billingdocument === 'TOTALES'?'':formattedDate}</span>;
                    }}/>

                <Column field="shortdescription" header="" className="columnGen column100px" body={(record) => {
                        return <span style={{ paddingTop: '2px', paddingBottom: '3px', paddingLeft: record.billingdocument === 'TOTALES'?'50%':'', paddingRight: record.billingdocument === 'TOTALES'?'50%':'', background: record.billingdocument === 'TOTALES'? '#FAFFB2' : 'inherit' }}>{record.shortdescription}</span>
                    }}/>
                <Column field="posnumber" header="Comprobante" className="columnGen column100px" body={(record) => {
                        return <span style={{ paddingTop: '2px', paddingBottom: '3px', paddingLeft: record.billingdocument === 'TOTALES'?'50%':'', paddingRight: record.billingdocument === 'TOTALES'?'50%':'', background: record.billingdocument === 'TOTALES'? '#FAFFB2' : 'inherit' }}>{record.posnumber}</span>
                    }}/>
                <Column field="formnumber" header="" className="columnGen column100px" body={(record) => {
                        return <span style={{ paddingTop: '2px', paddingBottom: '3px', paddingLeft: record.billingdocument === 'TOTALES'?'50%':'', paddingRight: record.billingdocument === 'TOTALES'?'60%':'', background: record.billingdocument === 'TOTALES'? '#FAFFB2' : 'inherit' }}>{record.formnumber}</span>
                    }}/>

                <Column field="billingname" header="Proveedor" className="columnGen columnCvy" body={(record) => {
                        return <span style={{ paddingTop: '2px', paddingBottom: '3px', paddingLeft: record.billingdocument === 'TOTALES'?'50%':'', paddingRight: record.billingdocument === 'TOTALES'?'60%':'', background: record.billingdocument === 'TOTALES'? '#FAFFB2' : 'inherit' }}>{record.billingname}</span>
                    }}/>
                <Column field="billingdocument" header="C.U.I.T." className="columnGen columnCUIT" body={(record) => {
                        return <span style={{ paddingTop: '2px', paddingBottom: '3px', paddingRight: record.billingdocument === 'TOTALES'?'60%':'', background: record.billingdocument === 'TOTALES'? '#FAFFB2' : 'inherit' }}>{record.billingdocument}</span>
                    }}/>
                <Column field="taxvalue" header="Tasa" className="columnGen columnOx" body={(record) => {
                        return <span style={{ paddingTop: '2px', paddingBottom: '3px', paddingLeft: record.billingdocument === 'TOTALES'?'50%':'', paddingRight: record.billingdocument === 'TOTALES'?'50%':'', background: record.billingdocument === 'TOTALES'? '#FAFFB2' : 'inherit' }}>{record.taxvalue}</span>
                    }}/>
                <Column field="netamount" header="Neto gravado" className="columnGen column100px" body={(record) => {
                        return <span style={{ paddingTop: '2px', paddingBottom: '3px', paddingLeft: record.billingdocument === 'TOTALES'?'1%':'', paddingRight: record.billingdocument === 'TOTALES'?'90%':'', background: record.billingdocument === 'TOTALES'? '#FAFFB2' : 'inherit' }}>{record.netamount}</span>
                    }}/>
                <Column field="netamountnottaxed" header="Exento/No gravado" className="columnGen column100px" body={(record) => {
                        return <span style={{ paddingTop: '2px', paddingBottom: '3px', paddingLeft: record.billingdocument === 'TOTALES'?'1%':'', paddingRight: record.billingdocument === 'TOTALES'?'90%':'', background: record.billingdocument === 'TOTALES'? '#FAFFB2' : 'inherit' }}>{record.netamountnottaxed}</span>
                    }}/>
                <Column field="vatamount" header="Monto IVA" className="columnGen column100px" body={(record) => {
                        return <span style={{ paddingTop: '2px', paddingBottom: '3px', paddingLeft: record.billingdocument === 'TOTALES'?'1%':'', paddingRight: record.billingdocument === 'TOTALES'?'90%':'', background: record.billingdocument === 'TOTALES'? '#FAFFB2' : 'inherit' }}>{record.vatamount}</span>
                    }}/>
                <Column field="vatperceptionvalue" header="Percepc. de IVA" className="columnGen column100px" body={(record) => {
                        return <span style={{ paddingTop: '2px', paddingBottom: '3px', paddingLeft: record.billingdocument === 'TOTALES'?'1%':'', paddingRight: record.billingdocument === 'TOTALES'?'90%':'', background: record.billingdocument === 'TOTALES'? '#FAFFB2' : 'inherit' }}>{record.vatperceptionvalue}</span>
                    }}/>
                <Column field="taxesamount" header="Otro Impuesto" className="columnGen column100px" body={(record) => {
                        return <span style={{ paddingTop: '2px', paddingBottom: '3px', paddingLeft: record.billingdocument === 'TOTALES'?'1%':'', paddingRight: record.billingdocument === 'TOTALES'?'90%':'', background: record.billingdocument === 'TOTALES'? '#FAFFB2' : 'inherit' }}>{record.taxesamount}</span>
                    }}/>
                <Column field="iibbvalue" header="Ingresos brutos" className="columnGen column100px" body={(record) => {
                        return <span style={{ paddingTop: '2px', paddingBottom: '3px', paddingLeft: record.billingdocument === 'TOTALES'?'1%':'', paddingRight: record.billingdocument === 'TOTALES'?'90%':'', background: record.billingdocument === 'TOTALES'? '#FAFFB2' : 'inherit' }}>{record.iibbvalue}</span>
                    }}/>
                <Column field="notinscribedvalue" header="No inscrip." className="columnGen column100px" body={(record) => {
                        return <span style={{ paddingTop: '2px', paddingBottom: '3px', paddingLeft: record.billingdocument === 'TOTALES'?'1%':'', paddingRight: record.billingdocument === 'TOTALES'?'90%':'', background: record.billingdocument === 'TOTALES'? '#FAFFB2' : 'inherit' }}>{record.notinscribedvalue}</span>
                    }}/>
                <Column field="monotributevalue" header="Monotrib" className="columnGen column100px" body={(record) => {
                        return <span style={{ paddingTop: '2px', paddingBottom: '3px', paddingLeft: record.billingdocument === 'TOTALES'?'1%':'', paddingRight: record.billingdocument === 'TOTALES'?'90%':'', background: record.billingdocument === 'TOTALES'? '#FAFFB2' : 'inherit' }}>{record.monotributevalue}</span>
                    }}/>
                <Column field="amount" header="Total" className="columnGen column100px" body={(record) => {
                        const digits = record.amount? record.amount.toString().length : 0;
                        const decreasePercentage = digits > 0 ? digits * 9.69 + '%' : '0%';
                        return <span style={{ paddingTop: '2px', paddingBottom: '3px', paddingLeft: record.billingdocument === 'TOTALES'?'1%':'', paddingRight: record.billingdocument === 'TOTALES'?`calc(100% - ${decreasePercentage})`:'', background: record.billingdocument === 'TOTALES'? '#FAFFB2' : 'inherit' }}>{record.amount}</span>
                    }}/>
            </CustomTable>

            <CustomTable
                idTable={useId()}
                ref={tableRef}
                showGridlines
                hideFiltersButton
                getItems={getAliquotTotalizers}
                params={{ 
                    fromDate: fromDate,
                    toDate: toDate
                }}
                className='crudTable mt-6'
            >
                <Column field="description" header="Descripción" className="columnGen"/>
                <Column field="totaltaxablebase" header="Total base imponible" className="columnGen"
                    body={(rowData) => rowData.totaltaxablebase === 0 ? '--' : rowData.totaltaxablebase}/>
                <Column field="totaltax" header="Total impuesto" className="columnGen"
                    body={(rowData) => rowData.totaltax === 0 ? '--' : rowData.totaltax}/>
            </CustomTable>
            
        </div>
    )
    

}

export default VATPurchasesView;